import {
  areImpactShopBasketProductsEqual,
  ImpactShopBasketProduct,
  Currency,
  ImpactShopProductPrice,
} from "@ecologi/shared";

export const findProduct = (
  basket: ImpactShopBasketProduct[],
  productToFind: ImpactShopBasketProduct
) =>
  basket.find((product) =>
    areImpactShopBasketProductsEqual(product, productToFind)
  );

/**
 * Return total quantity of a specific product within the basket
 */
export const getTotalProductQuantity = (
  basket: ImpactShopBasketProduct[],
  productToFind: ImpactShopBasketProduct
) =>
  basket.reduce(
    (acc, product) =>
      product.id === productToFind.id ? acc + product.quantity : acc,
    0
  );

export const getProductPrice = (
  prices: ImpactShopProductPrice[],
  currency: Currency
) => prices.find((price) => price.currency === currency).amount;

export const updateProductAttribute = (
  basket: ImpactShopBasketProduct[],
  productToUpdate: ImpactShopBasketProduct,
  attribute:
    | { amount: number; overwrite: boolean }
    | { fundedBy: string }
    | { groupId: number | null }
) => [
  ...basket.map((product) => {
    if (!areImpactShopBasketProductsEqual(product, productToUpdate)) {
      return product;
    }

    const updatedProduct = { ...product };

    if ("amount" in attribute) {
      updatedProduct.quantity = attribute.overwrite
        ? attribute.amount
        : product.quantity + attribute.amount;
    }

    if ("fundedBy" in attribute) {
      updatedProduct.fundedBy = attribute.fundedBy;
    }

    if ("groupId" in attribute) {
      if (attribute.groupId === null) {
        delete updatedProduct.groupId;
      } else {
        updatedProduct.groupId = attribute.groupId;
      }
    }

    return updatedProduct;
  }),
];
